// import { useState } from "react";
// import { Routes, Route } from "react-router-dom";
// import "./App.css";

// import Layout from "./Layout";

// import Home from "./pages/Home";
// import Products from "./pages/Products";
// import Store from "./pages/Store";
// import StoreDetails from "./pages/StoreDetails";
// import Contact from "./pages/Contact";
// import Cart from "./pages/Cart";
// import Checkout from "./pages/Checkout";
// import OrderSuccess from "./pages/OrderSuccess";
// import CategoryProducts from "./pages/CategoryProducts";
// import Navbar from "./components/Navbar";


// export default function App() {


//   const [cart, setCart] = useState([]);

//   const [language, setLanguage] = useState("en");



//   // const addToCart = (product) => {

//   //   setCart((prevCart)=>{


//   //     const exist = prevCart.find(
//   //       item => item.id === product.id
//   //     );


//   //     if(exist){

//   //       return prevCart.map(item=>

//   //         item.id === product.id

//   //         ? {
//   //             ...item,
//   //             qty:(item.qty || 1) + 1
//   //           }

//   //         : item

//   //       );

//   //     }


//   //     return [
//   //       ...prevCart,
//   //       {
//   //         ...product,
//   //         qty:1
//   //       }
//   //     ];


//   //   });


//   // };




// const addToCart = (product) => {

//   setCart((prevCart)=>{

//     const exist = prevCart.find(
//       item => item.id === product.id
//     );

//     if(exist){

//       return prevCart.map(item =>
//         item.id === product.id
//         ? {
//             ...item,
//             qty:item.qty + 1
//           }
//         : item
//       );

//     }

//     return [
//       ...prevCart,
//       {
//         ...product,
//         qty:1
//       }
//     ];

//   });

// };

//   const increaseQty = (id)=>{

//     setCart(prev=>

//       prev.map(item=>

//         item.id === id

//         ? {
//             ...item,
//             qty:(item.qty || 1)+1
//           }

//         : item

//       )

//     );

//   };





//   const decreaseQty = (id)=>{


//     setCart(prev=>

//       prev.map(item=>

//         item.id === id

//         ? {
//             ...item,
//             qty:Math.max((item.qty || 1)-1,1)
//           }

//         : item

//       )

//     );


//   };





//   const totalPrice = cart.reduce(

//     (sum,item)=>

//       sum +

//       Number(item.price || item.smallPrice || 0) *

//       Number(item.qty || 1)

//   ,0);




//   return (

//     <Routes>


//       <Route

//         path="/"

//         element={

//           <Layout

//             cart={cart}

//             language={language}

//             setLanguage={setLanguage}

//           />

//         }

//       >



//         <Route

//           index

//           element={

//             <Home

//               cart={cart}

//               setCart={setCart}

//               addToCart={addToCart}

//               language={language}

//             />

//           }

//         />





//         <Route

//           path="products"

//           element={

//             <Products

//               addToCart={addToCart}

//               language={language}

//             />

//           }

//         />





//         <Route

//           path="category/:category"

//           element={

//             <CategoryProducts

//               cart={cart}

//               setCart={setCart}

//               addToCart={addToCart}

//               language={language}

//             />

//           }

//         />





//         <Route

//           path="stores"

//           element={

//             <Store

//               language={language}

//             />

//           }

//         />





//         <Route

//           path=":slug"

//           element={

//             <StoreDetails

//               language={language}

//             />

//           }

//         />





//         <Route

//           path="contact"

//           element={

//             <Contact

//               language={language}

//             />

//           }

//         />





//         <Route

//           path="cart"

//           element={

//             <Cart

//               cart={cart}

//               increaseQty={increaseQty}

//               decreaseQty={decreaseQty}

//               totalPrice={totalPrice}

//               language={language}

//             />

//           }

//         />





       


// <Route 
// path="/checkout" 
// element={
// <Checkout 
// cart={cart}
// totalPrice={totalPrice}
// />
// }
// />







//         <Route

//           path="order-success"

//           element={<OrderSuccess />}

//         />



//       </Route>
// <Route>
// <Navbar
//     cartCount={
//       cart.reduce(
//         (total, item) => total + item.qty,
//         0
//       )
//     }
//   />
// </Route>
//     </Routes>

//   );

// }
import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

import Layout from "./Layout";

import Home from "./pages/Home";
import Products from "./pages/Products";
import Store from "./pages/Store";
import StoreDetails from "./pages/StoreDetails";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import CategoryProducts from "./pages/CategoryProducts";


export default function App() {


const [cart, setCart] = useState([]);

const [language, setLanguage] = useState("en");

const [notifications, setNotifications] = useState([]);



// ADD TO CART

const addToCart = (product)=>{


setCart((prevCart)=>{


const exist = prevCart.find(
item=>item.id === product.id
);



if(exist){

return prevCart.map(item=>

item.id === product.id

?

{
...item,
qty:(item.qty || 1)+1
}

:

item

);

}



return [

...prevCart,

{
...product,
qty:1
}

];


});



// Notification

setNotifications(prev=>[

...prev,

{

id:Date.now(),

title:"Product Added",

description:`${product.name || product.title} added to cart`

}

]);


};




// INCREASE QTY

const increaseQty=(id)=>{

setCart(prev=>

prev.map(item=>

item.id===id

?

{
...item,
qty:(item.qty || 1)+1
}

:

item

)

);

};




// DECREASE QTY

const decreaseQty=(id)=>{


setCart(prev=>

prev.map(item=>

item.id===id

?

{
...item,
qty:Math.max((item.qty || 1)-1,1)
}

:

item

)

);


};




// TOTAL PRICE

const totalPrice = cart.reduce(

(sum,item)=>

sum+

Number(
item.price ||
item.smallPrice ||
item.mrp ||
0
)

*

Number(item.qty || 1)

,0

);




return (

<Routes>


<Route

path="/"

element={

<Layout

cartCount={
cart.reduce(
(total,item)=>total+item.qty,
0
)
}

cart={cart}

notifications={notifications}

language={language}

setLanguage={setLanguage}

/>

}

>


{/* HOME */}

<Route

index

element={

<Home

cart={cart}

addToCart={addToCart}

language={language}

/>

}

/>



{/* PRODUCTS */}

<Route

path="products"

element={

<Products

addToCart={addToCart}

language={language}

/>

}

/>



{/* CATEGORY */}

<Route

path="category/:category"

element={

<CategoryProducts

cart={cart}

addToCart={addToCart}

language={language}

/>

}

/>



{/* STORES */}
{/* 
<Route

path="stores"

element={

<Store

language={language}

/> */}

{/* }

/> */}


{/* <Route path="stores" element={<Store language={language} />} />
<Route path="/stores/:slug" element={<StoreDetails />} /> */}
  <Route path="/" element={<Home />} />

  <Route path="/stores" element={<Store />} />

  <Route path="/:slug" element={<StoreDetails />} />

{/* <Route path="stores/:slug" element={<StoreDetails />} />

<Route path="es" element={<Store language={language} />} />

<Route path="/es" element={<StoreDetails storeSlug="ecom-store" />} /> */}
{/* CONTACT */}

<Route

path="contact"

element={

<Contact

language={language}

/>

}

/>



{/* CART */}

<Route

path="cart"

element={

<Cart

cart={cart}

setCart={setCart}

increaseQty={increaseQty}

decreaseQty={decreaseQty}

totalPrice={totalPrice}

language={language}

/>

}

/>



{/* CHECKOUT */}

<Route

path="checkout"

element={

<Checkout

cart={cart}

setCart={setCart}

totalPrice={totalPrice}

language={language}

/>

}

/>



{/* ORDER SUCCESS */}

<Route

path="order-success"

element={

<OrderSuccess/>

}

/>



{/* STORE DETAILS */}

{/* <Route

path=":slug"

element={

<StoreDetails

language={language}

/> */}

{/* }

/> */}



</Route>


</Routes>

);


}